import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class UserApi {

    static authUser(username, password) {
        const formParamsUrlEncoded = new URLSearchParams();
        formParamsUrlEncoded.set('username', username);
        formParamsUrlEncoded.set('password', password);
        formParamsUrlEncoded.set('grant_type', 'password');
        formParamsUrlEncoded.set('scope', 'webclient');

        const requestOptions = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Basic d2ViY2xpZW50OnR5UGczM0hO'
            }
        };

        return HTTP.post(config.userApi.auth, formParamsUrlEncoded, requestOptions)
            .then(response => response.data);
    }

    static sendBusinessCard(email, companyName) {
        const formParamsUrlEncoded = new URLSearchParams();
        formParamsUrlEncoded.set('email', email);
        formParamsUrlEncoded.set('companyName', companyName);
        return HTTP.post("/simple-contact-request", formParamsUrlEncoded)
            .then(response => response.data);
    }

    static logout() {
        return HTTP.post(`${config.userApi.logout}`)
            .then(response => response.data);

    }

    static fetchUser(id) {
        return HTTP.get(`${config.userApi.user}/${id}`)
            .then(response => response.data);
    }

    static fetchAll(page, items, filter) {
        return HTTP.get(`${config.userApi.user}/${page}/${items}/${filter}`)
            .then(response => response.data);
    }

    static fetchCurrentUser() {
        return HTTP.get(config.userApi.session)
            .then(response => response.data);
    }

    static delete(id) {
        return HTTP.delete(`${config.userApi.user}/${id}`)
            .then(response => response.data);
    }

    static add(user) {
        return HTTP.post(config.userApi.user, user)
            .then(response => response.data);
    }

    static update(user) {
        return HTTP.put(config.userApi.user, user)
            .then(response => response.data);
    }

    static register(user) {
        return HTTP.post(config.userApi.register, user)
            .then(response => response.data);
    }

    static isKnownEmail(email) {
        return HTTP.post(config.userApi.emailCheck, {email: email})
            .then(response => response.data);
    }

    static updateCurrencySetting(userSettings) {
        return HTTP.post('/users/settings', userSettings)
            .then(response => response.data);
    }

    static changePassword(password, oldPassword) {
        const formParamsUrlEncoded = new URLSearchParams();
        formParamsUrlEncoded.set('password', password);
        formParamsUrlEncoded.set('oldPassword', oldPassword);
        return HTTP.post('/users/updatePassword', formParamsUrlEncoded)
            .then(response => response.data);
    }

    static activate(token) {
        return HTTP.get(`${config.userApi.activate}/${token}`)
            .then(response => response.data);
    }

    static recoverPassword(passwordRecovery) {
        return HTTP.post(config.userApi.passwordRecovery, passwordRecovery)
            .then(response => response.data);
    }

    static confirmUser(userId) {
        return HTTP.post(`${config.userApi.user}/confirm/${userId}`)
            .then(response => response.data);
    }

    static sendOrderNotificationMail(userId) {
        return HTTP.post(`${config.userApi.user}/order/subscription/${userId}`)
            .then(response => response.data);
    }

    static migrateUser(userId) {
        return HTTP.post(`${config.userApi.user}/migrate/${userId}`)
            .then(response => response.data);
    }

}